import {
  AppPageHeader,
  DeleteIcon,
  EditIcon,
  InfiniteTable,
} from '@/components/_common';
import {
  useInstallmentTagsDelete,
  useInstallmentTagsList,
} from '@/core/domain/financial/InstallmentTags/InstallmentTags.hooks';
import {
  InstallmentTag,
  InstallmentTagsQueryFilter,
} from '@/core/domain/financial/InstallmentTags/InstallmentTags.type';
import { useDebounce, useDisclosure } from '@/hooks';
import { convertParams, usePersistSearchParams } from '@/utils/queryParams';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Divider, Modal, Space, Tag } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React, { useState } from 'react';
import TagsAccountsPayableAndReceivableModal from '../TagsAccountsPayableAndReceivableModal';

export default function TagsAccountsPayableAndReceivableList() {
  const [queryParams, setQueryParams] = useState<InstallmentTagsQueryFilter>({
    order: 'ASC',
    ...convertParams<InstallmentTagsQueryFilter>({
      search: 'string',
    }),
  });

  const [tagSelected, setTagSelected] = useState<InstallmentTag>();
  const [modalEditOpened, modalEditActions] = useDisclosure();

  const queryDebounce = useDebounce(queryParams, 500);
  usePersistSearchParams(queryDebounce);

  const list = useInstallmentTagsList(queryDebounce);

  const workOrderTags = flatInfiniteData(list.data);

  const remove = useInstallmentTagsDelete();

  const handleRemoveClick = (id: number) => {
    Modal.confirm({
      title: 'Atenção!',
      content: 'Deseja realmente excluir essa etiqueta?',
      onOk: async () => {
        await remove.mutateAsync(id);
      },

      okType: 'danger',
    });
  };

  const columns: ColumnsType<InstallmentTag> = [
    {
      dataIndex: 'name',
      title: 'Descrição',
      render: (_, record) => (
        <Tag color={record.color}>{record.name.toUpperCase()}</Tag>
      ),
    },
    {
      dataIndex: 'actions',
      title: 'Ações',
      render: (_, row) => (
        <Space>
          <EditIcon
            iconProps={{
              onClick: () => {
                setTagSelected(row);
                modalEditActions.open();
              },
            }}
          />

          <Divider type="vertical" />

          <DeleteIcon onClick={() => handleRemoveClick(row.id)} />
        </Space>
      ),
      width: 100,
      align: 'right',
      fixed: 'right',
    },
  ];

  return (
    <>
      <AppPageHeader
        searchValue={queryParams.search}
        onSearch={(value) =>
          setQueryParams((prev) => ({ ...prev, search: value }))
        }
      />

      <InfiniteTable<InstallmentTag>
        columns={columns}
        dataSource={workOrderTags}
        loading={list.isFetching}
        rowKey={(row) => row.id}
        hasNextPage={list.hasNextPage}
        fetchNextPage={list.fetchNextPage}
      />

      <TagsAccountsPayableAndReceivableModal
        tagDetail={tagSelected}
        open={modalEditOpened}
        onCancel={() => {
          modalEditActions.close();
          setTagSelected(undefined);
        }}
      />
    </>
  );
}
